export const FruitsIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.6458 21.7745L12.4948 21.7442L12.3438 21.7745C9.90426 22.2624 7.60119 21.9911 5.91877 20.6451C4.24522 19.3063 3 16.7545 3 12.2648C3 7.67322 4.03459 5.80784 5.39721 5.12654C6.10995 4.77017 7.03165 4.66646 8.20445 4.80178C9.37586 4.93695 10.7275 5.30194 12.2513 5.80987L12.5189 5.89905L12.7806 5.79432C15.328 4.77534 17.6178 4.38501 19.2261 5.13559C20.7343 5.8394 21.9896 7.7414 21.9896 12.2648C21.9896 16.7545 20.7444 19.3063 19.0708 20.6451C17.3883 21.9911 15.0853 22.2624 12.6458 21.7745Z"
          stroke={fill}
        />
        <path
          d="M12.4947 5.59262C12.4947 3.02646 11.4682 2 9.41528 2"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
